<template>
      <div class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <h3>Profil Perusahaan</h3>

              <div class="alert alert-info" role="alert" v-show="data.loading">
                Loading...
              </div>
              
              <div class="card">
                <div class="card-body">
                  <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating text-secondary">Nama PT</label>
                          <input type="text" class="form-control" placeholder="Nama PT..." v-model="data.nama">
                        </div>
                        <div class="form-group">
                          <label class="bmd-label-floating text-secondary">Alamat PT</label>
                          <input type="text" class="form-control" placeholder="Alamat PT..." v-model="data.alamat">
                        </div>
                        <div class="form-group">
                          <label class="bmd-label-floating text-secondary">Nama & Nomer Rek  (Ini untuk di tampilkan di teks tagihan ke mitra)</label>
                          <input type="text" class="form-control" placeholder="Nama Rek..." v-model="data.an">
                          <input type="number" class="form-control" placeholder="Nomer Rek..." v-model="data.rek">
                          <input type="text" class="form-control" placeholder="BANK..." v-model="data.bank">
                        </div>
                        <div class="form-group" v-if="data.email != null">
                          <label class="bmd-label-floating text-secondary">OTP (Email : {{data.email}})</label>
                          <input type="text" class="form-control" placeholder="Kode Verifikasi" v-model="data.otp">
                          <button class="btn btn-sm btn-info" @click="update.otp()" v-show="data.otpBtn">Req OTP</button>
                          <small class="text-muted">nb : Biasanya masuk di spam ya gan emailnya hehe</small>
                        </div>
                        <div class="form-group" v-else>
                          <h4 class="text-info m-0">Anda belum menautkan email</h4>
                        </div>
                        <div class="form-group" v-show="data.email != null">
                          <button class="btn btn-success mb-2" @click="update.submit()">Simpan</button>
                          <div class="alert alert-danger" role="alert" v-if="update.form.alert != null">
                            {{update.form.alert}}
                          </div>
                          <div class="alert alert-success" role="alert" v-if="update.form.alertSuccess != null">
                            {{update.form.alertSuccess}}
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating text-secondary">Logo Kop Tagihan</label><br>
                          <img v-show="data.logoUploaded != ''" class="icon" :src="data.urlaset+''+data.logoUploaded+'?version='+data.rand" alt="" style="width: 250px">
                          <span v-show="data.logoUploaded == ''">
                            <input type="file" class="form-control file-upload" accept="image/*" @change="update.logoChange">
                            <input type="hidden" class="form-control" placeholder="Nama..." v-model="data.logo"> 
                            <button class="btn btn-sm btn-info" @click="update.uploadLogo()">Upload Logo</button>
                          </span>
                          <span v-show="data.logoUploaded != ''">
                            <button class="btn btn-sm btn-info" @click="data.logoUploaded = ''">Ganti Logo</button>
                          </span>
                        </div>
                        <div class="form-group">
                          <label class="bmd-label-floating text-secondary">Gambar Tanda Tangan</label><br>
                          <img v-show="data.ttdUploaded != ''" class="icon" :src="data.urlaset+''+data.ttdUploaded+'?version='+data.rand" alt="" style="width: 250px">
                          <span v-show="data.ttdUploaded == ''">
                            <input type="file" class="form-control file-upload" accept="image/*" @change="update.ttdChange">
                            <input type="hidden" class="form-control" placeholder="Nama..." v-model="data.ttd"> 
                            <button class="btn btn-sm btn-info" @click="update.uploadTtd()">Upload TTD</button>
                          </span>
                          <span v-show="data.ttdUploaded != ''">
                            <button class="btn btn-sm btn-info" @click="data.ttdUploaded = ''">Ganti Logo</button>
                          </span>
                        </div>
                        <div class="form-group">
                          <div class="alert alert-danger" role="alert" v-if="update.form.alertLogo != null">
                            {{update.form.alertLogo}}
                          </div>
                          <div class="alert alert-success" role="alert" v-if="update.form.alertSuccessLogo != null">
                            {{update.form.alertSuccessLogo}} 
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import { urlAssets } from '@/var/var.js'

export default {
  name: 'Beranda',
	components: { 

	}, 
  setup() {
    const data = reactive({
      urlaset: '',
      nama: '',
      alamat: '',
      rek: '',
      an: '',
      bank: '',
      email: '',
      otp: '',
      otpBtn: true,

      logo: '',
      logoUploaded: '', 
      ttd: '',
      ttdUploaded: '',

      loading: true,

      rand: 0
    })
    const update = {

      form : reactive({
        alert: null,
        alertSuccess: null,
        alertLogo: null,
        alertSuccessLogo: null
      }),
      
      ttdChange(e) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length)
            return;
            data.ttd = files[0];
          
      },
      uploadTtd() {
        var datax = new FormData();
        datax.append('image_file', data.ttd);
        datax.append('ke', 'ttd');
        datax.append('token', 'TangTung '+sessionStorage.getItem('myToken'));

        var apiUrl = inter.getPerusahaanUploads();
        myGlobal.call(datax,apiUrl).then(x => {      
                
            if (x.status == true) {

              data.rand = data.rand + 1;

              data.ttdUploaded = "";
              data.ttdUploaded = x.data;

              this.form.alertSuccessLogo = x.pesan;

            } else {

              this.form.alertLogo = x.pesan;

            }

        })
      },
      
      logoChange(e) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length)
            return;
            data.logo = files[0];
          
      },
      uploadLogo() {
        var datax = new FormData();
        datax.append('image_file', data.logo);
        datax.append('ke', 'logo');
        datax.append('token', 'TangTung '+sessionStorage.getItem('myToken'));

        var apiUrl = inter.getPerusahaanUploads();
        myGlobal.call(datax,apiUrl).then(x => {         
          
          console.log(JSON.stringify(x));
          
          if (x.status == true) {

            data.rand = data.rand + 1;

            data.logoUploaded = "";
            data.logoUploaded = x.data;

            this.form.alertSuccessLogo = x.pesan;

          } else {

            this.form.alertLogo = x.pesan;

          }

        })
      },

      submit() {

        if (data.nama == "" || data.alamat == "" || data.rek == "" || data.an == "" || data.email == "" || data.otp == "" || data.bank == "" ) {
          this.form.alert = "Lengkapi data diatas terlebih dahulu";
          return false;
        }

        this.form.alert = null;

        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          nama: data.nama,
          alamat: data.alamat,
          rek: data.rek,
          an: data.an,
          otp: data.otp,
          bank: data.bank
        }
        
        var apiUrl = inter.UpdatePerusahaan();
        myGlobal.call(datax,apiUrl).then(x => {            
            if (x.status == true) {
                //data.datae = x.data;
              this.form.alert = null;
              this.form.alertSuccess = x.pesan;
              data.otp = '';
              sessionStorage.removeItem("otped");

            } else {
              this.form.alert = x.pesan;
            }

        })

      },
      otp() {

        if (data.nama == "" || data.alamat == "" || data.rek == "" || data.an == "" || data.email == "" || data.bank == "" ) {
          this.form.alert = "Lengkapi data diatas terlebih dahulu";
          return false;
        }

        if (sessionStorage.getItem("otped") != null) {
          this.form.alert = "Anda telah req kode OTP ya. Mohon periksa email lagi gan.";
          data.otpBtn = false;
          return false;
        }

        data.otpBtn = false;

        sessionStorage.setItem("otped", 'ya'); // telah req otp

        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken')
        }
        
        var apiUrl = inter.getPerusahaanOTP();
        myGlobal.call(datax,apiUrl).then(x => {

          
          if (x.status == true) {
            

          } else {

              this.form.alert = x.pesan;

          }
            
        })
      },
      read() {

        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken')
        }
        
        var apiUrl = inter.getPerusahaan();
        myGlobal.call(datax,apiUrl).then(x => {

          data.loading = false;
          
          if (x.status == true) {
              //data.datae = x.data;

              var d = x.data.pt;

              data.email = x.data.email;
              data.nama = d.nama;
              data.alamat = d.alamat;
              data.rek = d.rek;
              data.bank = d.bank;
              data.an = d.an;
              data.logoUploaded = "perusahaan_logo/"+d.logo;
              data.ttdUploaded = "perusahaan_ttd/"+d.ttd;
 
          } else {

              //this.form.alert = x.pesan;

          }
            
        })

      }
    }
    return {
      data,
      myGlobal,
      update
    }
  },
  mounted () {
    document.title = "Update Profil";
    this.data.wa = sessionStorage.getItem("PPN");

    this.update.read();

    this.data.urlaset = urlAssets;

    this.data.rand = Math.floor(Math.random() * 10);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.file-upload {
  position: relative !important;
  z-index: 0 !important;
  opacity: 1 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mitra/perusahaan.vue